import { useEffect, useState } from 'react';
export const useIsBrowser = () => {
    const [isBrowser, setIsBrowser] = useState(false);
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    return isBrowser;
};
//# sourceMappingURL=useIsBrowser.js.map